import React from 'react'
import NewPaymentModal from './NewPaymentModal'
import { StateProvider } from '../state'
import AddPaymentButton from './AddPaymentButton'
import RoyaltiesToPayModal from './RoyaltiesToPayModal'
import CommissionsToPayModal from './CommissionsToPayModal'
import reducer from '../reducer'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'

const App = () => {
  const initialState = {
    newPaymentModalOpen: false,
    royaltyModalOpen: false,
    commissionModalOpen: false,
    newPaymentDescription: '',
    newPaymentAmount: '',
    newPaymentTransactionID: '',
    newPaymentCoursenum: '',
    royaltiesOwed: [],
    newSource: '',
    newInvoiceNumber: '',
    commissions: [],
    paymentItemId: '',
    salespeople: [],
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <AddPaymentButton />
      <NewPaymentModal />
      <RoyaltiesToPayModal />
      <CommissionsToPayModal />
    </StateProvider>
  )
}

export default App
